import { useGamificationContext } from '@/shared/Gamification/GamificationContext/GamificationContext';

export default function useInteractiveVideoActivity({
  activity,
  taskProgressActions,
  seoActions,
}) {
  const gamificationContext = useGamificationContext();
  const actions = {
    shared: {
      onActivityStart: async () => {
        if (taskProgressActions) {
          await taskProgressActions.createProgress({
            activityType: 'interactiveVideo',
            progress: 0,
          });
        }
        seoActions.onStart();
      },
      onActivityProgress: async ({ progress, correct, answers }) => {
        const answer = answers?.[answers.length - 1];
        gamificationContext.actions.putData({
          activityId: activity.id,
          progress,
          correctAnswers: answer?.correct ? [answer?.id] : [],
        });

        if (taskProgressActions) {
          await taskProgressActions.updateProgress({
            activityType: 'interactiveVideo',
            progress,
            correct,
            answers,
          });
        }
        seoActions.onProgress({ progressData: { progress } });
      },
      onActivityRestart: async () => {
        console.log('Creating a new progress');
        if (taskProgressActions) {
          await taskProgressActions.createProgress({
            activityType: 'interactiveVideo',
            progress: 0,
          });
          taskProgressActions.onActivityRestarted();
        }
        seoActions.onStart();
      },
      goToNextTaskActivity: taskProgressActions?.goToNextTaskActivity,
    },
  };

  return {
    state: {
      noSeek:
        gamificationContext.state.isGamificationStudent ||
        !!taskProgressActions,
    },
    actions,
  };
}
